import { FontSet, Theme } from '@app/@core/entities/common.entities';

export const themeList: Theme[] = [
  {
    name: 'Default',
    image: '/assets/images/skin_default.svg',
    key: 'default',
    properties: {
      '--background-color': '#F8F8F8',
      '--header-bg': '#f7f7f7',
      '--navigation': '#fff',
      '--primary': '#005A9C',
      '--checkbox-border': '#a2a2a2',
      '--text-dark': '#000',
      '--label-text': '#005A9C',
      '--hover-text': '#fff',
      '--bg-light': '#F8F8F8',
      '--profile-bg': '#f3f9f9',
      '--forms': '#fff',
      '--nav-text': '#000',
      '--light-gray': '#696969',
      '--material-icons': '#005A9C',
      '--highlight-list': '#E5F6FF',
      '--table-header': '#f9f9f9',
      '--table-odd': '#f7f7f7',
      '--table-border': '#ddd',
      '--table-hover': '#dbf6ff',
      '--btn': '#005A9C',
      '--menu-panel': '#032361',
      '--menu-level2': '#28447E',
      '--border-trans': 'transparent',
      '--btn-hover': '#1258A7',
      '--btn-dark': '#005A9C',
      '--dropdown-list': '#fff',
      '--btncancel': '#005A9C',
      '--primary-light': '#1258A7',
      '--primary-hover': '#0070F4',
      '--primary-dark': '#005A9C ',
      '--light-d-light': '#fff',
      '--ldl-text': '#fff',
      '--light-d-accent': '#fff',
      '--secondary-color': '#005A9C',
      '--menu-link': '#1258A7',
      '--menu-highlight': '#0084d1',
      '--submenu-selected': '#0084D1',
      '--disabled': '#7A8EB5',
      '--accordion-header': '#F5F5F5',
      '--menu-hover': '#1258A7',
      '--header-color': '#4C4C4C',
      '--interactive-color': '#0049E5',
      '--form-outline': '#D6D5D5',
      '--table-body': '#1F1F1F',

      '--var-icon-font': '"FILL" 0, "wght" 600, "GRAD" 0, "opsz" 48',

      '--rocket-icon': '/assets/images/rocket-ship.svg'
    }
  },
  {
    name: 'Light',
    image: '/assets/images/skin_light.svg',
    key: 'light',
    properties: {
      '--background-color': '#f3f3f3',
      '--header-bg': '#f3f3f3',
      '--navigation': '#fff',
      '--primary': '#343344',
      '--checkbox-border': '#343344',
      '--text-dark': '#000',
      '--label-text': '#000',
      '--hover-text': '#fff',
      '--bg-light': '#F8F8F8',
      '--profile-bg': '#f3f9f9',
      '--forms': '#fff',
      '--nav-text': '#000',
      '--light-gray': '#696969',
      '--material-icons': '#005A9C',
      '--highlight-list': '#E5F6FF',
      '--table-header': '#f9f9f9',
      '--table-odd': '#fff',
      '--table-border': '#ddd',
      '--table-hover': '#F6FCFF',
      '--btn': '#343344',
      '--menu-panel': '#fff',
      '--menu-level2': '#fff',
      '--border-trans': 'transparent',
      '--btn-hover': '#005A9C',
      '--btn-dark': '#343344',
      '--dropdown-list': '#fff',
      '--btncancel': '#343344',
      '--primary-light': '#6e6b93',
      '--primary-dark': '#f5f5f5',
      '--light-d-light': '#343344',
      '--ldl-text': '#000',
      '--light-d-accent': '#343344',
      '--secondary-color': '#343344',
      '--menu-link': '#6c757d',
      '--menu-highlight': '#343344',
      '--submenu-selected': '#0084D1',
      '--disabled': '#7A8EB5',
      '--accordion-header': '#005A9C',

      '--var-icon-font': '"FILL" 0, "wght" 500, "GRAD" 0, "opsz" 48',

      '--rocket-icon': '/assets/images/rocket-ship.svg'
    }
  },
  {
    name: 'Dark',
    image: '/assets/images/skin_dark.svg',
    key: 'dark',
    properties: {
      '--background-color': '#181f36',
      '--header-bg': '#1a2035',
      '--navigation': '#272e46',
      '--nav-text': '#fff',
      '--light-gray': '#a3a3a3',
      '--primary': '#f3266b',
      '--checkbox-border': '#8b8989',
      '--text-dark': '#ddd',
      '--label-text': '#fff',
      '--hover-text': '#fff',
      '--bg-light': '#272e46',
      '--profile-bg': '#40475e',
      '--material-icons': '#fff',
      '--forms': '#272e46',
      '--highlight-list': '#E5F6FF',
      '--table-header': '#364060',
      '--table-odd': '#2f364c',
      '--table-border': '#3e414c',
      '--table-hover': '#F6FCFF',
      '--btn': '#f3266b',
      '--menu-panel': '#272e46',
      '--menu-level2': '#272e46',
      '--border-trans': 'transparent',
      '--btn-hover': '#f3266b',
      '--btn-dark': '#f3266b',
      '--dropdown-list': '#29314a',
      '--btncancel': 'transparent',
      '--primary-light': '#a75872',
      '--primary-dark': '#202534',
      '--light-d-light': '#fff',
      '--ldl-text': '#fff',
      '--light-d-accent': '#a75872',
      '--secondary-color': '#202534',
      '--menu-link': '#cdcdcd',
      '--menu-highlight': '#f3266b',
      '--submenu-selected': '#0084D1',
      '--disabled': '#7A8EB5',
      '--accordion-header': '#202534',

      '--var-icon-font': '"FILL" 0, "wght" 200, "GRAD" 0, "opsz" 48',

      '--rocket-icon': '/assets/images/rocket-ship_light.svg'
    }
  }
];

export const FontSetList: FontSet[] = [
  {
    name: 'Medium',
    key: 'medium',
    properties: {
      '--base-font-size': '16px',
      '--font-11': '11px',
      '--font-12': '12px',
      '--font-13': '13px',
      '--font-14': '14px',
      '--font-15': '15px',
      '--font-16': '16px',
      '--font-17': '17px',
      '--font-18': '18px',
      '--font-19': '19px',
      '--font-20': '20px',
      '--font-21': '21px',
      '--font-24': '24px',
      '--font-26': '26px'
    }
  },
  {
    name: 'Large',
    key: 'large',
    properties: {
      '--base-font-size': '15px',
      '--font-11': '13px',
      '--font-12': '14px',
      '--font-13': '15px',
      '--font-14': '16px',
      '--font-15': '17px',
      '--font-16': '18px',
      '--font-17': '19px',
      '--font-18': '20px',
      '--font-19': '21px',
      '--font-20': '22px',
      '--font-21': '23px',
      '--font-24': '28px',
      '--font-26': '30px'
    }
  }
];
